import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import casinobg1 from '../assets/casino-with-casino-casino-table-1024x575.png'
import casinolifestyle from '../assets/photorealistic-casino-lifestyle-1024x683.png'

const AboutUsPage = () => {
    return (
        <div className="wp-singular page-template page-template-elementor_header_footer page page-id-3243 wp-custom-logo wp-embed-responsive wp-theme-hello-elementor theme-default elementor-default elementor-template-full-width elementor-kit-3179 elementor-page elementor-page-3243">
            <Navigation />
            <div data-elementor-type="wp-page" data-elementor-id="3243" className="elementor elementor-3243"
                data-elementor-post-type="page">
                <div className="elementor-element elementor-element-8e410f5 e-flex e-con-boxed e-con e-parent" data-id="8e410f5"
                    data-element_type="container">
                    <div className="e-con-inner">
                        <div className="elementor-element elementor-element-aec2ec9 elementor-widget elementor-widget-heading"
                            data-id="aec2ec9" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                                <h1 className="elementor-heading-title elementor-size-default">About Us</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="elementor-element elementor-element-836c28d e-flex e-con-boxed e-con e-parent" data-id="836c28d"
                    data-element_type="container">
                    <div className="e-con-inner">
                        <div className="elementor-element elementor-element-b9b3cc4 e-con-full e-flex e-con e-child"
                            data-id="b9b3cc4" data-element_type="container">
                            <div className="elementor-element elementor-element-d0bc046 elementor-widget elementor-widget-image"
                                data-id="d0bc046" data-element_type="widget" data-widget_type="image.default">
                                <div className="elementor-widget-container">
                                    <img decoding="async" width="800" height="449"
                                        src={casinobg1}
                                        className="attachment-large size-large wp-image-3665" alt="" />
                                </div>
                            </div>
                            <div className="elementor-element elementor-element-900a4da elementor-widget elementor-widget-heading"
                                data-id="900a4da" data-element_type="widget" data-widget_type="heading.default">
                                <div className="elementor-widget-container">
                                    <h2 className="elementor-heading-title elementor-size-default">Quem Somos</h2>
                                </div>
                            </div>
                            <div className="elementor-element elementor-element-b9df7c7 elementor-widget elementor-widget-text-editor"
                                data-id="b9df7c7" data-element_type="widget" data-widget_type="text-editor.default">
                                <div className="elementor-widget-container">
                                    Bem-vindo ao Casinoplusportugal – o seu guia de confiança no universo dos casinos online
                                    regulamentados em Portugal.

                                    Não somos operadores de jogo. Somos uma plataforma de comparação independente, criada para
                                    ajudar jogadores como você a encontrar casinos online seguros, legais e licenciados pelo
                                    Serviço de Regulação e Inspeção de Jogos (SRIJ) – a entidade reguladora oficial em Portugal.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="elementor-element elementor-element-28007fe e-flex e-con-boxed e-con e-parent" data-id="28007fe"
                    data-element_type="container">
                    <div className="e-con-inner">
                        <div className="elementor-element elementor-element-a7027cb e-flex e-con-boxed e-con e-child"
                            data-id="a7027cb" data-element_type="container"
                            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                            <div className="e-con-inner">
                                <div className="elementor-element elementor-element-0e092af elementor-widget elementor-widget-heading"
                                    data-id="0e092af" data-element_type="widget" data-widget_type="heading.default">
                                    <div className="elementor-widget-container">
                                        <h2 className="elementor-heading-title elementor-size-default">A Nossa Missão</h2>
                                    </div>
                                </div>
                                <div className="elementor-element elementor-element-232ec6b elementor-widget elementor-widget-text-editor"
                                    data-id="232ec6b" data-element_type="widget" data-widget_type="text-editor.default">
                                    <div className="elementor-widget-container">
                                        <p>A nossa missão é clara:<br />Fornecer informação honesta, atualizada e transparente
                                            aos jogadores.</p>
                                        <p>Quer seja um utilizador experiente ou esteja a começar no mundo dos jogos online,
                                            queremos ajudá-lo a tomar decisões informadas através de comparações lado a lado,
                                            análises especializadas e guias práticos — sempre baseados na legislação portuguesa.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="elementor-element elementor-element-9a09db7 e-flex e-con-boxed e-con e-parent" data-id="9a09db7"
                    data-element_type="container">
                    <div className="e-con-inner">
                        <div className="elementor-element elementor-element-decc1a1 e-con-full e-flex e-con e-child"
                            data-id="decc1a1" data-element_type="container">
                            <div className="elementor-element elementor-element-1ffe60d elementor-widget elementor-widget-heading"
                                data-id="1ffe60d" data-element_type="widget" data-widget_type="heading.default">
                                <div className="elementor-widget-container">
                                    <h2 className="elementor-heading-title elementor-size-default">Por Que Confiar em Nós?</h2>
                                </div>
                            </div>
                            <div className="elementor-element elementor-element-b033aa9 elementor-widget elementor-widget-text-editor"
                                data-id="b033aa9" data-element_type="widget" data-widget_type="text-editor.default">
                                <div className="elementor-widget-container">
                                    <ul>
                                        <li>Independentes e imparciais – não operamos nem promovemos nenhum casino.</li>
                                        <li>Foco na regulamentação – apenas listamos casinos licenciados pelo SRIJ.</li>
                                        <li>Conhecimento local – criado para jogadores portugueses, com conhecimento do mercado
                                            nacional.</li>
                                        <li>Avaliações transparentes – todas as análises são baseadas em critérios reais, não em
                                            publicidade.</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="elementor-element elementor-element-8bafa5e elementor-widget elementor-widget-heading"
                                data-id="8bafa5e" data-element_type="widget" data-widget_type="heading.default">
                                <div className="elementor-widget-container">
                                    <h2 className="elementor-heading-title elementor-size-default">O Que Fazemos</h2>
                                </div>
                            </div>
                            <div className="elementor-element elementor-element-8c335b6 elementor-widget elementor-widget-text-editor"
                                data-id="8c335b6" data-element_type="widget" data-widget_type="text-editor.default">
                                <div className="elementor-widget-container">
                                    <p>No Casinoplusportugal, analisamos e comparamos casinos licenciados em várias categorias:</p>
                                    <ul>
                                        <li>Bónus de boas-vindas e promoções</li>
                                        <li>Variedade de jogos (slots, jogos de mesa, casino ao vivo, etc.)</li>
                                        <li>Métodos de pagamento populares em Portugal</li>
                                        <li>Experiência em dispositivos móveis</li>
                                        <li>Segurança, licenciamento e suporte ao cliente</li>
                                        <li>Também fornecemos recursos e conselhos sobre jogo responsável, para garantir que o
                                            jogo continue a ser uma atividade saudável e divertida.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="elementor-element elementor-element-7e9f0cb e-con-full e-flex e-con e-child"
                            data-id="7e9f0cb" data-element_type="container">
                            <div className="elementor-element elementor-element-aae0b09 elementor-widget elementor-widget-image"
                                data-id="aae0b09" data-element_type="widget" data-widget_type="image.default">
                                <div className="elementor-widget-container">
                                    <img decoding="async" width="800" height="534"
                                        src={casinolifestyle}
                                        className="attachment-large size-large wp-image-3663" alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default AboutUsPage